import { Flex, Form } from 'antd';
import { useEffect, useState } from 'react';

import { updateProfile, uploadAvatar } from '@/apis';
import * as AuthComponent from '@/components/Auth';
import AvatarUploader from '@/components/AvatarUploader';
import OutlinedButton from '@/components/OutlinedButton';
import { useAuth } from '@/contexts/AuthContext';
import { useLoading } from '@/contexts/LoadingContext';
import { ButtonHtmlType } from '@/enums';

interface ProfileFormValues {
  name: string;
}

export default function ProfilePage() {
  const [form] = Form.useForm<ProfileFormValues>();
  const [avatarPath, setAvatarPath] = useState('');
  const [avatarFile, setAvatarFile] = useState<File | null>(null);
  const { token, profile, profileLoading, loadProfile } = useAuth();
  const { withLoading } = useLoading();

  useEffect(() => {
    if (profile) {
      form.setFieldsValue({ name: profile.name });
      setAvatarPath(profile.avatarUrl || '');
    }
  }, [profile, form]);

  const onFinish = async (values: ProfileFormValues) => {
    await withLoading(async () => {
      let path = avatarPath;
      if (avatarFile) {
        const response = await uploadAvatar(avatarFile);
        if (response && response.data) {
          path = response.data.objectPath;
          setAvatarFile(null);
          setAvatarPath(response.data.objectPath);
        }
      }
      await updateProfile({ name: values.name, avatarUrl: path });
      await loadProfile();
    });
  };

  if (!token) return <p>Not logged in</p>;
  if (profileLoading || !profile) return <p>Loading...</p>;

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="vertical"
      requiredMark={false}
      style={{ width: '100%' }}
    >
      <Flex vertical style={{ maxWidth: '30%', margin: '0 auto' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '24px' }}>個人資料</h2>

        <Form.Item
          name="name"
          rules={[
            {
              required: true,
              message: '請輸入姓名',
            },
          ]}
        >
          <AuthComponent.Input
            type="text"
            placeholder="請輸入姓名"
            width="100%"
            height="3.5rem"
          />
        </Form.Item>

        <AvatarUploader currentPath={avatarPath} onFileChange={setAvatarFile} />

        <Flex gap="1rem" style={{ alignSelf: 'center', marginTop: '24px' }}>
          <OutlinedButton
            htmlType={ButtonHtmlType.Submit}
            height="4rem"
            width="8rem"
          >
            儲存
          </OutlinedButton>
        </Flex>
      </Flex>
    </Form>
  );
}
